<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.161 1h-3.516c-2.086 0-4.407.878-4.407 3.902.01 1.054 0 2.063 0 3.2H6.824v3.84h2.489V23h4.572V11.87h3.019l.273-3.78h-3.37s.007-1.68 0-2.169c0-1.195 1.243-1.127 1.318-1.127.592 0 1.743.002 2.038 0V1h-.002Z"
      fill="currentColor"
    />
  </svg>
</template>
